export const COMMERCIAL_NETWORKS = {
  REDEBAN: 250,
  CREDIBANCO: 1101,
  CREDIBANCO_USD: 1102,
  PAYMENTEZ_ECU: 1150,
  PAYMENTEZ_PER: 1151,
  COOPENAE: 2020,
  COOPENAE_USD: 2021,
  LAFISE: 1400,
  LAFISE_USD: 1401,
  NIUBIZ: 1500,
  NIUBIZ_USD: 1501,
  MOVII: 1600
};

export const COMMERCIAL_NETWORKS_NAMES = {
  REDEBAN: 'REDEBAN',
  CREDIBANCO: 'CREDIBANCO',
  CREDIBANCO_USD: 'CREDIBANCO_USD',
  PAYMENTEZ_ECU: 'PAYMENTEZ_ECU',
  PAYMENTEZ_PER: 'PAYMENTEZ_PER',
  COOPENAE: 'COOPENAE',
  COOPENAE_USD: 'COOPENAE_USD',
  LAFISE: 'LAFISE',
  LAFISE_USD: 'LAFISE_USD',
};

export const COMMERCIAL_NETWORKS_TIMEZONES = {
  COL: 'America/Bogota',
  CRC: 'America/Costa_Rica'
}
